import { bootstrapApplication } from '@angular/platform-browser';
import { setScriptKey } from '@progress/kendo-licensing';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { unregisterStaleServiceWorkers } from './app/core/utils/stale-service-worker.util';

if (environment.kendoLicenseKey) {
  setScriptKey(environment.kendoLicenseKey);
}

unregisterStaleServiceWorkers(environment.production)
  .then(() => bootstrapApplication(AppComponent, appConfig))
  .catch((err) => console.error(err));
